import * as React from 'react';

interface ItemProps {
  label: string;
  selected: boolean;
  onClick: (e: React.MouseEvent) => void;
}

const TabBarItem: React.FunctionComponent<ItemProps> = props => {
  return (
    <div
      className={`tab-bar-view-item ${
        props.selected ? 'tab-bar-view-item--selected' : ''
      }`}
      onClick={props.onClick}
    >
      {props.label}
    </div>
  );
};

interface Props {
  items: string[];
  selectedIndex: number;
  onChange: (index: number) => void;
  style?: React.CSSProperties;
}

export const TabBarView: React.FunctionComponent<Props> = props => {
  return (
    <div className="tab-bar-view" style={props.style}>
      {props.items.map((item, index) => (
        <TabBarItem
          label={item}
          key={index}
          selected={props.selectedIndex === index}
          onClick={() => props.onChange(index)}
        />
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/TabBarView.tsx